import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import modal from 'decorators/Modal/Modal';
import { decorateWith } from 'helpers/decorator';
import { selectIsMobile } from 'redux/modules/device';
export var BillingTrustModalUnwrapped = function BillingTrustModalUnwrapped(_ref) {
  var isMobile = _ref.isMobile,
      onModalClose = _ref.onModalClose;
  return React.createElement("section", {
    className: "checkout__modal"
  }, React.createElement("header", {
    className: "text--center"
  }, React.createElement("h2", {
    className: "mb-- delta text--bold"
  }, React.createElement(FormattedMessage, {
    id: "checkout.billing-trust-modal.header",
    defaultMessage: "Why we ask for your billing info"
  }))), React.createElement("p", {
    className: "mb+"
  }, React.createElement(FormattedHTMLMessage, {
    id: "checkout.billing-trust-modal.copy-paragraph-1",
    defaultMessage: "<strong>Your trial is completely free</strong>, but our <a href='https://help.classpass.com/hc/en-us/articles/207942743-What-is-the-class-cancellation-policy' target='_blank'>class cancellation policy</a> still applies. If you can\u2019t make a class that you\u2019ve booked, make sure to cancel at least 12 hours beforehand to avoid a fee. Otherwise, for most classes, it\u2019s $15 to late cancel and $20 if you miss the class without canceling."
  })), React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "checkout.billing-trust-modal.copy-paragraph-2",
    defaultMessage: "After your free trial, you\u2019ll be auto-enrolled in our most popular plan. You can cancel your auto-enrollment at any point during your trial. Once on a monthly plan, you can change or cancel your membership at any time."
  })), React.createElement("button", {
    className: classNames('bt bt--primary bt--outline bt--lg', {
      'bt--width-lg': !isMobile,
      'bt--width-full': isMobile
    }),
    type: "submit",
    onClick: onModalClose
  }, React.createElement(FormattedMessage, {
    id: "checkout.billing-trust-modal.cta",
    defaultMessage: "Got it"
  })));
};
BillingTrustModalUnwrapped.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired
};
export var mapStateToProps = function mapStateToProps(state) {
  return {
    isMobile: selectIsMobile(state)
  };
};
export var BillingTrustModal = decorateWith(connect(mapStateToProps), modal({
  headerClass: 'modal--720'
}))(BillingTrustModalUnwrapped);